<template>
  <div>
    <Banner :titulo="banner.title" :image="banner.image" :respimage="banner.resp_image" />
    <section class="Jobs">
      <div class="container">
        <h2 class="title-box">{{$t("trabalhe-conosco.titulo")}}</h2>

        <div class="container-list-jobs">
          <div class="block-list-jobs" v-for="job in jobs">
            <span>{{ job.title }}</span>
            <router-link
              :to="{ name: 'Trabalheconosco', params: { slug: job.slug } }"
              class="more-info-job"
            >{{$t("trabalhe-conosco.detalhes")}}</router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="Tem-vaga bg-gray">
      <div class="container">
        <h2 class="title-box">{{$t("trabalhe-conosco.nao-encontrou")}}</h2>

        <article>
          <p>{{$t("trabalhe-conosco.envie-seu-curriculo")}}</p>
        </article>

        <form
          method="post"
          action="https://back.stormsec.com.br/job"
          enctype="multipart/form-data"
          @submit="submitForm($event)"
        >
          <div class="left-contato">
            <fieldset class="form-item validar">
              <input
                type="text"
                name="name"
                class="src"
                autocomplete="off"
                id="nome"
                value
                :placeholder="$t('trabalhe-conosco.nome') + ' *'"
              />
              <span class="span-error">{{$t('trabalhe-conosco.campo_obrigatorio')}}</span>
            </fieldset>

            <fieldset class="form-item validar">
              <input
                type="text"
                class="src"
                name="email"
                autocomplete="off"
                :placeholder="$t('trabalhe-conosco.email') + ' *'"
                id="email"
                value
              />
              <span class="span-error">{{$t('trabalhe-conosco.campo_obrigatorio')}}</span>
            </fieldset>

            <fieldset class="form-item">
              <input
                type="text"
                name="phone"
                autocomplete="off"
                :placeholder="$t('trabalhe-conosco.telefone') + ' *'"
                v-mask="'(##) ####-#####'"
                class="src"
                id="telefone"
                value
              />
            </fieldset>
          </div>

          <div class="right-contato">
            <fieldset class="form-item">
              <input
                type="text"
                name="portfolio"
                autocomplete="off"
                :placeholder="$t('trabalhe-conosco.portifolio') + ' *'"
                class="src"
                id="portfolio"
                value
              />
            </fieldset>

            <fieldset class="form-item">
              <input
                type="text"
                name="linkedin"
                autocomplete="off"
                placeholder="LinkedIn"
                class="src"
                id="linkedin"
                value
              />
            </fieldset>

            <fieldset class="form-item">
              <input
                type="file"
                name="attach"
                id="attach"
                style="display: none;"
                @change="change($event.target)"
              />
              <input type="hidden" name="upload-file" id="upload-file" />
              <div class="anexo" @click="bind($event.target)">{{$t('trabalhe-conosco.anexar')}}</div>
            </fieldset>
          </div>

          <div class="button-contato">
            <div class="msg-success-error">
              <!--<span v-if="success">Mensagem enviada com sucesso!!!</span>-->
            </div>
            <label id="text-right" class="text-right" v-if="display">Enviando ...</label>
            <img src="/static/loading.gif" width="30" v-if="display" />
            <input
              type="submit"
              :style="{ display: disable }"
              id="enviar"
              :value="$t('trabalhe-conosco.enviar')"
              v-if="disable"
              @click="clickGA()"
            />
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import VueI18n from "vue-i18n";

import Banner from "../shared/Banner";
import BannerService from "../../domain/bannerService";
import JobService from "../../domain/JobService";
import VueTheMask from "vue-the-mask";
import { TheMask } from "vue-the-mask";
import { mask } from "vue-the-mask";

Vue.use(VueTheMask);

export default {
  components: {
    Banner,
    TheMask,
  },
  watch: {
    "$i18n.locale": function () {
      this.init();
    },
  },
  directives: { mask },

  methods: {
    clickGA() {
      this.$ga.event({
        eventCategory: "Trabalhe Conosco",
        eventAction: "submit",
        eventLabel: "Enviar",
        eventValue: 2,
        transport: "beacon",
      });
    },

    bind(ev) {
      document.getElementById("attach").click();
    },

    change(event) {
      this.selectedField = event.files[0];
    },

    submitForm(event) {
      this.target = event.target;
      event.preventDefault();
      this.inputs = this.target.getElementsByClassName("src");

      for (let a = 0; a < this.inputs.length; a++) {
        this.value =
          this.inputs[a].value !== "message"
            ? this.inputs[a].value
            : this.inputs[a].text;
        this.name = this.inputs[a].name;
        if (this.inputs[a].parentNode.classList.contains("validar")) {
          if (this.value === "") {
            this.inputs[a].parentNode.classList.add("error");
          } else {
            this.inputs[a].parentNode.classList.remove("error");
            if (!this.validateEmail()) {
              document
                .getElementById("email")
                .parentNode.classList.add("error");
            } else {
              document
                .getElementById("email")
                .parentNode.classList.remove("error");
            }
          }
        }
      }

      if (document.getElementsByClassName("error").length <= 0) {
        this.display = true;
        this.disable = "none";
        this.success = true;
        this.target.submit();
      }
    },

    validateEmail() {
      let email = document.getElementById("email").value;
      let filtro = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

      return filtro.test(email);
    },
    init() {
      Vue.http.headers.common["Content-Language"] = this.$i18n.locale;
      this.serviceJobs.jobs().then((res) => {
        this.jobs = res;
        return this.jobs;
      });
      this.bannerService.blocks().then((res) => {
        this.banner = res;
        this.banner = this.banner[0];
        return this.banner;
      });
    },
  },

  created() {
    this.serviceJobs = new JobService(this.$resource);
    this.bannerService = new BannerService(this.$resource, "TRABALHE");
    this.init();
  },

  data() {
    return {
      titulo: "Trabalhe conosco",
      display: false,
      disable: "block",
      success: false,
      selectedField: null,
      jobs: null,
      banner: [],
    };
  },
};
</script>

<style lang="scss">
.Jobs {
  padding: 60px 0;
  background: #ffffff;

  h2 {
    margin-bottom: 80px;
  }

  .container-list-jobs {
    width: 960px;
    margin: 0 auto;

    .block-list-jobs {
      display: flex;
      border-bottom: 1px solid #ccc;
      padding: 25px 0;
      align-items: center;
      justify-content: space-between;

      &:first-child {
        border-top: 1px solid #ccc;
      }

      span {
        font-size: 22px;
        color: #222831;
        flex-basis: 60%;
      }

      .more-info-job {
        font-size: 15px;
        background: #3ab8e8;
        padding: 10px 20px 11px 20px;
        color: #ffffff;
        font-weight: 100;
        border-radius: 4px;
        cursor: pointer;
      }
    }
  }
}
.Tem-vaga {
  padding: 60px 0;

  article {
    p {
      margin: 0 auto;
      font-size: 20px;
      color: #222931;
      text-align: center;
      line-height: 35px;
    }
  }

  form {
    width: 960px;
    margin: 80px auto 30px auto;
    display: flex;
    flex-basis: 100%;
    flex-wrap: wrap;
    justify-content: space-around;

    .actions {
      flex-basis: calc(100% - 24px);

      .msg-success-error {
        float: left;
        color: #1cfc7b;
        font-size: 18px;
        font-style: italic;
        margin-top: 25px;
      }
    }

    .left-contato {
      flex-basis: 49%;
    }

    .right-contato {
      flex-basis: 49%;
    }

    fieldset {
      width: 100%;
      margin-bottom: 20px;
      position: relative;

      .anexo {
        width: 90%;
        height: 45px;
        line-height: 40px;
        border: 1px solid #222931;
        color: #222931;
        background: transparent;
        font-size: 16px;
        text-align: center;
        cursor: pointer;
      }

      span {
        display: none;
      }

      &.error {
        text-align: left;

        span {
          width: 80%;
          color: red;
          display: block;
          text-align: left;
          font-size: 14px;
          font-style: italic;
          font-weight: normal;
          position: absolute;
          top: 45px;
          left: 0;
        }
      }

      img {
        margin-right: 20px;
        margin-top: 15px;
      }

      label {
        width: 100px;
        display: block;
        float: left;
        margin-right: 20px;
        font-size: 18px;
        text-align: right;
        line-height: 40px;
        color: #ffffff;

        &.text-right {
          width: calc(100% - 70px);
          margin-right: 20px;
          line-height: 60px;
        }
      }

      input {
        width: 90%;
        height: 40px;
        display: block;
        float: left;
        border: none;
        padding: 10px 0;
        background: none;
        border-bottom: 2px solid #cccccc;
        font-size: 16px;
        color: #222931;
        margin-bottom: 10px;
        font-style: italic;

        &::placeholder {
          color: #222931;
          font-style: italic;
        }
      }
    }

    .button-contato {
      flex-basis: 90%;
      display: flex;

      .msg-success-error {
        flex-basis: 90%;
        color: #1f9350;
        font-size: 18px;
        font-style: italic;
      }

      .text-right {
        font-size: 18px;
        color: #444444;
        margin: 5px 10px 0 0;
      }

      #enviar {
        width: 120px;
        height: 50px;
        color: #ffffff;
        display: block;
        background: #3ab8e8;
        border-radius: 6px;
        font-size: 17px;
        float: right;
        padding: 10px 0;
        font-weight: normal;
        border: 1px solid #3ab8e8;
      }
    }
  }
}

@media (max-width: 640px) {
  .Jobs {
    .container-list-jobs {
      width: 100%;
    }
  }

  .Tem-vaga {
    article {
      p {
        text-align: left;
      }
    }

    form {
      width: 100%;
      margin-top: 30px;

      .button-contato {
        flex-basis: 100%;
        justify-content: center;

        .msg-success-error {
          display: none;
        }
      }

      fieldset {
        input {
          width: 100%;
        }
        .anexo {
          width: 100%;
        }
      }

      .left-contato {
        flex-basis: 100%;
      }

      .right-contato {
        flex-basis: 100%;
      }
    }
  }
}

@media (max-width: 360px) {
  .Jobs {
    .container-list-jobs {
      .block-list-jobs {
        padding: 0;

        span {
          flex-basis: 40%;
        }

        .more-info-job {
          font-size: 15px;
          padding: 10px 15px 11px 15px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/Jobs.vue